import React, { createContext, useState, useMemo } from "react";
export const AdvancedOptionsContext = createContext(void 0);
export const AdvancedOptionsProvider = ({ children }) => {
  const [isAdvancedOptionsVisible, setAdvancedOptionsVisibility] = useState(false);
  const [isAWSCustomEndpointsVisible, setAWSCustomEndpointsVisibility] = useState(false);
  const contextValue = useMemo(
    () => ({
      isAdvancedOptionsVisible,
      isAWSCustomEndpointsVisible,
      setAdvancedOptionsVisibility,
      setAWSCustomEndpointsVisibility
    }),
    [isAWSCustomEndpointsVisible, isAdvancedOptionsVisible]
  );
  return /* @__PURE__ */ React.createElement(AdvancedOptionsContext.Provider, { value: contextValue }, children);
};
